import { Box } from '@deity/falcon-ui';
import { BaseHelmet, PackageItem, PackageVersionItem, PackagesHeader, TRow, TableView, Thead } from 'components';
import { CACHE_FIRST, ENTITY_PATH_ID, PACKAGE_VERSION_PATH } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useGetAllPackageVersionsLazyQuery, useGetPackageLazyQuery } from 'services/graphql/generated/hooks';
import { getParams } from 'utils';

const PackageVersions: FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const params: { [key: string]: string } = getParams(pathname, [ENTITY_PATH_ID, PACKAGE_VERSION_PATH]);
  const [getPackage, { loading: packageLoading, data: packageData }] = useGetPackageLazyQuery(CACHE_FIRST);
  const [getAllPackageVersions, { data: packageVersions, refetch }] = useGetAllPackageVersionsLazyQuery();

  useEffect(() => {
    if (params?.packageId) {
      getPackage({
        variables: {
          uuid: params.packageId
        }
      });

      getAllPackageVersions({
        variables: {
          packageUuid: params.packageId,
          limit: 20,
          offset: 0
        }
      });
    }
  }, [pathname]);

  const latest = packageVersions?.getAllPackageVersions?.data[0];
  const packageInfo: any = {
    modifiedAt: latest?.modifiedAt,
    modifiedBy: latest?.modifiedBy,
    ...packageData?.getPackage
  };

  return (
    <>
      <BaseHelmet page="Package Versions" />
      <Box>
        <PackagesHeader onPackageCreated={() => history.push('/packages')} />
        <Box
          style={{ border: '1px solid #E0E2E5' }}
          borderRadius="medium"
          pt="lg"
          pb="lg"
          bg="white"
          boxShadow="subtle"
        >
          <TableView gridTemplateColumns="1.2fr 0.6fr 0.8fr 1fr repeat(3,0.6fr)">
            <Thead
              headerItems={[
                { text: 'name' },
                { text: 'history', cssProps: { justifySelf: 'center' } },
                { text: 'last modified' },
                { text: 'last modified by' },
                { text: 'last status' },
                { text: 'deployed versions', cssProps: { justifySelf: 'end' } }
              ]}
            />
            {packageData?.getPackage && (
              <TRow>
                <PackageItem {...packageInfo} />
              </TRow>
            )}
          </TableView>

          <TableView gridTemplateColumns="0.35fr 0.8fr 0.6fr 0.8fr 1fr repeat(3,0.6fr)">
            <Thead
              style={{ background: '#dadfe3' }}
              headerItems={[
                { text: '' },
                { text: 'name' },
                { text: 'version', cssProps: { justifySelf: 'center' } },
                { text: 'last modified' },
                { text: 'last modified by' },
                { text: 'status' },
                { text: 'deployment', cssProps: { justifySelf: 'end' } },
                { text: 'Action', cssProps: { justifySelf: 'end' } }
              ]}
            />
            {packageVersions?.getAllPackageVersions &&
              packageVersions?.getAllPackageVersions?.data
                .map((version, index) => (
                  <TRow key={version.uuid} style={{ background: '#f3f5f7' }} rowHeight="52px">
                    {packageData?.getPackage && (
                      <PackageVersionItem
                        name={packageData?.getPackage?.name}
                        packageUuid={packageData?.getPackage?.uuid}
                        {...version}
                        index={packageVersions.getAllPackageVersions.data.length - index}
                      />
                    )}
                  </TRow>
                ))
                .reverse()}
          </TableView>
        </Box>
      </Box>
    </>
  );
};

export default PackageVersions;
